import { Transformer as _Transformer } from "./Transformer";
export var Definition;
(function (Definition) {
    Definition.Transformer = _Transformer;
})(Definition || (Definition = {}));
//# sourceMappingURL=index.js.map